import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "../../../components";
import { ButtonType } from "../../../components/button";
import { GarageCartItem } from "../../../redux/garageCart/type";
import { getLocalized } from "../../../redux/localization";
import { Customer } from "../../../redux/offer/types";
import OfferAccept from "../offer-accept";
import OfferText from "../offer-text";
import "./style.scss";
const SummaryCard = ({
  data,
  isCreate,
}: {
  data: GarageCartItem[];
  isCreate: boolean;
}) => {
  const localize = useSelector(getLocalized);
  const [offerVisible, setOfferVisible] = useState(false);
  const [offerPdf, setOfferPdf] = useState(false);
  const [offerId, setOfferId] = useState<string>();
  const customerRef = useRef<Customer>({
    CompanyName: "",
    Email: "",
    Surname: "",
    Name: "",
    Phone: "",
    TaxOffice: "",
    TaxNumber: "",
    Approved: false,
  });

  return (
    <div className="summary-card">
      <div className="garageTitle px-3 py-3">
        {localize.getString("ordersummary")}
      </div>
      <table className="summary-card-table">
        <tr>
          <th className="garageText">{localize.getString("car")}</th>
          <th className="garageText">{localize.getString("price")}</th>
          <th className="garageText">{localize.getString("count")}</th>
        </tr>
        {data &&
          data.map((garageCartItem, i) => (
            <tr key={i}>
              <td className="garageSubText">
                <span className="garageSubBlondText">
                  {garageCartItem.Car?.CarBrand} {garageCartItem.Car?.CarModel}
                </span>
                <p>
                  {garageCartItem.Car?.CarVersion} {garageCartItem.Car?.CarPack}
                </p>
              </td>
              <td className="garageSubText">
                {new Intl.NumberFormat("tr-TR", {
                  maximumSignificantDigits: 20,
                }).format(
                  garageCartItem.Price?.PricePerMonth
                    ? garageCartItem.Price?.PricePerMonth
                    : 0
                )}{" "}
                TL
              </td>
              <td className="garageSubText">{garageCartItem.Count}</td>
            </tr>
          ))}
      </table>
      {isCreate && data.length > 0 && (
        <div
          style={{
            backgroundColor: "white",
            paddingBlock: 22,
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Button
            customClassName="btnGarajGonder"
            style={{
              width: "max-content",
              marginInlineEnd: 20,
              fontSize: 24,
              fontWeight: 700,
            }}
            buttonType={ButtonType.newColored}
            title={"TEKLİFİ TAMAMLA"}
            onClick={() => setOfferVisible(true)}
          />

          <OfferAccept
            data={data}
            customer={customerRef.current}
            buttonClick={(id?: string) => {
              setOfferVisible(false);
              setOfferId(id);
              setOfferPdf(true);
            }}
            visible={offerVisible}
            handleClose={() => setOfferVisible(false)}
          />
          <OfferText
            offerId={offerId}
            visible={offerPdf}
            handleClose={() => {
              setOfferPdf(false);
            }}
          />
        </div>
      )}
    </div>
  );
};
export default SummaryCard;
